import styled from "styled-components/macro";

import {useParams} from "react-router-dom";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import {useFeedback} from "../../store/feedback";
import {useSettings} from "../../store";
import NavLink from "../../components/nav_link";
import {isPseudoCommunity} from "../../store/communites";
import {useBlock} from "../../api/user";
import CommunityInfo from "../../components/community_info";
import {themecolors} from "../../utils/themecolors";

const Heading = styled.div``;
const Manage = styled.div``;
const Sort = styled.div``;
const SortOptions = styled.div``;
const Expand = styled.span``;
const Info = styled.div``;

const BlockedUser = styled(({className, username}) => {
    const {feedbackCh} = useFeedback();
    const block = useBlock(feedbackCh);
    const handleUnblock = async () => {
        try {
            await block(username);
        } catch {
        }
    };
    return (
        <tr className={className}>
            <td><NavLink href={`/u/${username}`} react_route>{username}</NavLink></td>
            <td>
                <Info onClick={handleUnblock}>
                    Unblock
                </Info>
            </td>
        </tr>
    )
})`
`;

const Blocks = styled(({logType, className}) => {
    const {error, feedbackCh} = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);

    const {blocked} = useSettings();

    return (
        <>
            <HeaderData title={`Blocked Users`} community={community} community_style={style}/>
            <Header>
                <TopBar/>
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                        <CommunityInfo desktop community={community} />
                    </>
                }
            </Header>
            <SortBar community={community}/>
            <Container className={className} forceWidth={"slim"}>
                <Wrapper>
                    <Main>
                        <table>
                            <tr>
                                <th>Username</th>
                            </tr>
                            {blocked && blocked.map((username) => (
                                <BlockedUser key={username} username={username}/>
                            ))}
                        </table>
                    </Main>
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} community={community}/>
            </Container>
            <Footer/>
        </>
    );
})`
  ${Main} {
    padding: 16px;
    font-size: 14px;
  }

  table {
    border-collapse: collapse;
    width: 100%;
  }

  th {
    text-align: left;
  }

  td svg {
    width: 14px;
    fill: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
  }

  ${Info} {
    display: flex;
    align-items: center;
    white-space: break-spaces;
  }

  ${Expand} {
    margin-left: 2px;
    cursor: pointer;
  }
  
  ${Sort} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
    cursor: pointer;
    white-space: nowrap;
    margin-left: 32px;
  }

  ${Sort} svg {
    margin-left: 12px;
  }

  ${SortOptions} {
    margin-left: auto;
    display: flex;
  }

  ${Info} {
    cursor: pointer;
  }
`;

export default Blocks;
